var _disabled =  document.querySelectorAll('.variant__button-label');
var n_disabled = Array.from(_disabled);
var _check = 0;
var input = document.querySelector(".js-qty__num");
var min = 10;
var max = 3000;

var v_default, v_min, v_max;

// 個数変更ボタンをarrayに入れる
n_disabled = 
n_disabled.filter(function(d) { 
    return !isNaN(String(d.innerHTML).slice(0,1))
});

document.addEventListener('DOMContentLoaded', function() {
  
    const buttonMinus = document.querySelector('.js-qty__adjust--minus');
    const buttonPlus = document.querySelector('.js-qty__adjust--plus');

    v_default = document.querySelector(".default");
    v_min = document.querySelector(".min");
    v_max = document.querySelector(".max");

    if (v_default != undefined && v_default != null) {
      input.value = v_default.innerHTML;
    } else {
      input.value = 10;
    }

    
    if (v_min != undefined && v_min != null) {
      min = v_min.innerHTML;
    }
    
    if (v_max != undefined && v_max != null) {
      max = v_max.innerHTML;
    }

    // input要素の値をチェックして制限を適用する関数
    function checkInputValue() {
        let value = parseInt(input.value, min);
        if (isNaN(value) || value < min) {
            input.value = String(min);
        } else if (value > max) {
            input.value = String(max);
        }

        for (var i = 0; i < _num.length; i ++) {
            if (i + 1 < _num.length){
              if (value >= _num[i] && _num[i + 1] > value) {
                _check = value;
                n_disabled[i].click();
                 break;
              } 
            } else {
              if (value >= 1000) {
                _check = input.value;
                n_disabled[i].click();
              }
            }
        } 
    }
      
    // inputイベントで値の変更を監視
    input.addEventListener('change', checkInputValue);

    // + ボタンのクリックイベント
    buttonPlus.addEventListener('click', function() {
        let value = parseInt(input.value, 10);
        for (var i = 0; i < _num.length; i ++) {
            if (value == _num[i]) {
                n_disabled[i].click();
            }
        } 
      
        if (value < max) {
            input.value = String(value);
        } else {
            input.value = String(max);
        }
    });

     // - ボタンのクリックイベント
    buttonMinus.addEventListener('click', function() {
        let value = parseInt(input.value, 10);
        for (var i = 0; i < _num.length; i ++) {
            if (value == _num[i] - 1) {
                _check = value;
                n_disabled[Math.max(i - 1, 0)].click();
            }
        }

        console.log(min);
        if (value > min) {
            input.value = String(value);
        } else {
            input.value = String(min);
        }
    });
  
});

// ボタンを押したとき購入数を任意の数に変更する
var _num = new Array();
var _btn_number = document.querySelectorAll('.btn_number');
for (var i = 0; i < _btn_number.length; i ++) {
    var _btnnum = _btn_number[i].innerHTML;
    _num.push(Number(_btnnum));
}
for (var i = 0; i < n_disabled.length; i ++) {
    (function(index) {
     n_disabled[index].addEventListener('click', function() {
        
          if (_check != 0) {input.value = _check;} else {
           input.value = String(_num[index]); 
          }
          _check = String(0);
        
      });}
    )(i);
}

// 値段などの変更
var _clickblock = document.querySelectorAll('.variant-input-wrap');
for (var i = 0; i < _clickblock.length; i++) {
    _clickblock[i].addEventListener('click', function(){
        // ページトップ以外に購入ボタンを追加したときに画面が移動しないようにする。
        ScrollWindow();
        alphaset();
        setTimeout(() => { buybuttonchange();}, 1);
        setTimeout(() => { transitionset();}, 1);
        setTimeout(() => { pricechange(); }, 2);
    });
}

// 購入オプションをページの下など複数配置した時の画面移動防止
var _price = document.querySelectorAll(".product__price");
var _ms = document.querySelector('.miyabe_price');
  if (_ms != undefined && _ms != null) {
  var _parent = _ms.parentElement;
  _parent.style.height = 0;
  function ScrollWindow() {
      if (window.pageYOffset > 3000) {
          document.documentElement.scrollTop = window.pageYOffset;
      }
  }
}

//値段変更時のアニメーション設定1
function alphaset() {
   // alpha 設定
   var _i = 0;
   while(_i < _price.length) {
       _price[_i].style.opacity = 0;
       _price[_i].style.transition = "all 0s";
       _i ++;
   }
}

//値段変更時のアニメーション設定2
function transitionset() {
   // alpha 設定
   var _l = 0;
   while(_l < _price.length) {
       _price[_l].style.transition = "all 0.3s";
       _l ++;
   }
}

// 購入ボタンのテキスト変更無効
function buybuttonchange() {
    var _add = document.querySelectorAll('.add-to-cart');
    var _set;
    var _txt = _add[0].innerHTML;
    var _pos1 = _txt.lastIndexOf('\"');
    var _pos2 = _txt.lastIndexOf('\"', _pos1 - 1);
    var _str1 = _txt.substr(_pos2 + 1, _pos1 - (_pos2 + 1));
    if (_str1 != "購入") {
        var _pos3 = _txt.indexOf(">");
        var _pos4 = _txt.lastIndexOf("<");
        var t = "購入";
        var a = _txt.substr(0, _pos2 + 1);
        var b = _txt.substr(_pos1, (_pos3 - _pos1) + 1);
        var c = _txt.substr(_pos4, 999);
        _set = a + t + b + t + c;
       _add[0].innerHTML = _set;
    }
}

function pricechange() {
      
      var _str = _price[0].textContent.replace(/[^0-9a-z]/gi, '');
      var _pricedata = document.querySelectorAll('.miyabe_price');
      var _set = 0;
      for (var l = 0; l < _pricedata.length; l ++) {
           var _txt = String(_pricedata[l].innerHTML).slice( 0, -2);
           if (String(_str) == _txt) {
               _set = Math.round(Number(_txt) * 1.1);
               _set = String(_set);
               var _n = _set.length;
               var _count = 0;
               while(_n > 3) {
                   _count ++;
                   var a = _set.slice(0, -3 * _count + (_count - 1) * -1);
                   var b = ",";
                   var c = _set.slice(_set.length -3 * _count + (_count - 1) * -1, _set.length);
                   _set = a + b + c;
                   _n = _n - 3; 
               }
               
               _set = _set + "円 <span class=" + "tax" + ">（税込)";
               break;
           } 
      }

      for (var i = 0; i < _price.length; i ++) {
            _price[i].style.opacity = 1;
            if (_set != 0) {　
              _price[i].innerHTML = _set; 
            }
      }
}